import _typeof from "@babel/runtime/helpers/typeof";

/**
 * Redact any value that appears with the property name "request". Picks out specific values and returns only those
 * in order to avoid logging too much. Also has perf benefits as we avoid recursively redacting the entire request
 * object.
 */
export var redactRequestProperty = {
  // Handle request being included in errors.
  test: function test(propertyName, value) {
    return propertyName === 'request' && _typeof(value) === 'object' && value !== null;
  },
  replacement: function replacement(value) {
    return {
      uri: value.uri,
      method: value.method,
      headers: {
        'X-Caller-Client-ID': value.headers && value.headers['X-Caller-Client-ID']
      }
    };
  }
};